const STORAGE_KEY = "wl_bs_musiclinks_extras";
const DELETED_STORAGE_KEY = "wl_bs_musiclinks_deleted";

function mergeById(baseRows, extraRows) {
  const map = new Map();
  (baseRows || []).forEach(row => {
    if (row && row.id != null) {
      map.set(String(row.id), row);
    }
  });
  (extraRows || []).forEach(row => {
    if (row && row.id != null) {
      map.set(String(row.id), { ...(map.get(String(row.id)) || {}), ...row });
    }
  });
  return Array.from(map.values());
}

function readRaw() {
  if (typeof sessionStorage === "undefined" && typeof localStorage === "undefined") {
    return [];
  }

  const readFromStorage = storage => {
    if (!storage) {
      return [];
    }
    try {
      const raw = storage.getItem(STORAGE_KEY);
      if (!raw) {
        return [];
      }
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  const sessionRows = typeof sessionStorage !== "undefined" ? readFromStorage(sessionStorage) : [];
  const localRows = typeof localStorage !== "undefined" ? readFromStorage(localStorage) : [];
  return mergeById(localRows, sessionRows);
}

function readDeletedRaw() {
  if (typeof sessionStorage === "undefined") {
    return [];
  }
  try {
    const raw = sessionStorage.getItem(DELETED_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}

function writeDeletedRaw(ids) {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.setItem(DELETED_STORAGE_KEY, JSON.stringify(ids || []));
  } catch {
    // no-op
  }
}

function writeRaw(rows) {
  const payload = JSON.stringify(rows || []);
  if (typeof sessionStorage !== "undefined") {
    try {
      sessionStorage.setItem(STORAGE_KEY, payload);
    } catch {
      // no-op
    }
  }
  if (typeof localStorage !== "undefined") {
    try {
      localStorage.setItem(STORAGE_KEY, payload);
    } catch {
      // no-op
    }
  }
}

export function getDemoMusicLinkRows() {
  const deletedIds = readDeletedRaw();
  return readRaw().filter(row => !deletedIds.includes(String(row?.id)));
}

export function upsertDemoMusicLinkRow(row) {
  if (!row || row.id == null) {
    return;
  }
  const sid = String(row.id);
  const deletedIds = readDeletedRaw().filter(id => id !== sid);
  writeDeletedRaw(deletedIds);
  const rows = readRaw();
  const idx = rows.findIndex(r => String(r.id) === sid);
  if (idx >= 0) {
    rows[idx] = { ...rows[idx], ...row };
  } else {
    rows.push(row);
  }
  writeRaw(rows);
}

export function getDeletedDemoMusicLinkIds() {
  return readDeletedRaw();
}

export function getActiveDemoMusicLinkSeedRows(seedRows) {
  const deletedIds = readDeletedRaw();
  return (seedRows || []).filter(row => !deletedIds.includes(String(row?.id)));
}

export function removeDemoMusicLinkRow(id) {
  if (id == null) {
    return;
  }
  const sid = String(id);
  const rows = readRaw().filter(row => String(row?.id) !== sid);
  writeRaw(rows);

  const deletedIds = readDeletedRaw();
  if (!deletedIds.includes(sid)) {
    writeDeletedRaw([...deletedIds, sid]);
  }
}
